import React from 'react';
import Card from '../../components/card/Card';
import styles from './Events.module.css';

const events = [
  {
    image: 'https://nha-waf.netlify.app/img/slider/2019.webp',
    heading: '2019「 四海一家」青年交流活動',
    text: '2019「四海一家」青年交流活動在香港特區政府和中聯辦的大力支持下，以「探索機遇‧卓越發展」為主題，帶領 2,000 名香港各界青年分別前往四川、浙江及粵港澳大灣區進行體驗式交流，了解歷史文化，學習國情時政，探索發展未來。',
    link: '2019',
  },
  {
    image: 'https://nha-waf.netlify.app/img/slider/2018.webp',
    heading: '2018「 四海一家」青年交流活動',
    text: '2018「四海一家」青年交流活動在香港特區政府和中聯辦的大力支持下，以「發展 ‧ 創新」為主題，帶領2,000 名香港青年分別前往陝西、天津及廣東交流，了解歷史文化、學習國情時政、探索發展未來。',
    link: '2018',
  },
  {
    image: 'https://nha-waf.netlify.app/img/slider/2017.webp',
    heading: '2017「四海一家·浙港同行」',
    text: '「四海一家‧浙港同行」浙港青年慶祝香港回歸祖國20周年交流活動以「成就·機遇」為主題，於2017年7月30日至8月4日期間組織約2,000名年齡介乎15-35歲的香港青少年前赴浙江交流，進行體驗式學習考察，並分別深入杭州、寧波、溫州、湖州、嘉興、紹興、金華、衢州、舟山、台州、麗水11個不同城市，感受浙江省不同地區的文化和發展。',
    link: '2017',
  },
];

const Events = () => {
  return (
    <section className={styles.container} id="events">
      {/*Map <Card /> */}
      {events.map(event => (
        <Card
          key={event.heading}
          image={event.image}
          heading={event.heading}
          text={event.text}
          link={event.link}
        />
      ))}
    </section>
  );
};

export default Events;
